import React from 'react';

import { agreementShape } from '../../prop-types';
import api from '../../REST/api';
import AuthorizedLink from '../../REST/AuthorizedLink';
import { agreementTypeToBillingType } from '../constants';

export default function CreateOpportunityLinkedToAgreement({ agreement }) {
  const {
    accountId,
    brandIds,
    salesUnit,
    businessModel,
    type,
    negotiatedBy,
    id,
  } = agreement;
  return (
    <AuthorizedLink
      to={{
        pathname: '/opportunities/add',
        state: {
          accountId,
          brandIds,
          salesUnit,
          businessModel,
          billingType: agreementTypeToBillingType[type],
          negotiatedBy,
          agreementOpportunities: [
            {
              agreement: id,
              budget: 0,
            },
          ],
        },
      }}
      className="btn btn-secondary"
      query={api.addOpportunity}
    >
      Create Opportunity
    </AuthorizedLink>
  );
}

CreateOpportunityLinkedToAgreement.propTypes = {
  agreement: agreementShape.isRequired,
};
